import { extendTheme, type ThemeConfig } from '@chakra-ui/react'
import { theme as baseMathleticsTheme } from '@3plearning/chakra-mathletics-theme'

import { ModalTheme } from './components/modal.theme'
import { ButtonTheme } from './components/button.theme'
import { breakpoints } from './foundations/breakpoints'
import { fonts } from './foundations/fonts'

const config: ThemeConfig = {
  initialColorMode: 'light',
  useSystemColorMode: false,
  cssVarPrefix: '3p'
}

export const studentComponentsTheme = extendTheme(baseMathleticsTheme, {
  config,
  breakpoints,
  fonts,
  styles: {
    global: {
      body: {
        fontFamily: '"sofia-pro", Verdana, sans-serif'
      }
    }
  },
  components: {
    Modal: ModalTheme,
    Button: ButtonTheme
  }
})
